import { ICampaignDataItem, Utils, Enums } from '@wix/promotions-types';
import { HttpClient } from '@wix/yoshi-flow-editor';
import { getViewerEssentials } from '../../viewer-utils';

export const getCampaign = async (campaignId: string, instance?: string) => {
  const httpClient = new HttpClient();
  const viewerFlowAPI = getViewerEssentials().flowAPI;
  instance = instance || (viewerFlowAPI.controllerConfig.appParams as string);
  const { Apis } = Enums.getAutoApiEndpoints(viewerFlowAPI);
  const campaign = (await Utils.DataItemApi(instance, httpClient).queryDataItem(
    campaignId,
    Apis,
  )) as ICampaignDataItem;

  return campaign;
};
